import { render, staticRenderFns } from "./menu.page.vue?vue&type=template&id=bb80f86a&"
import script from "./menu.page.vue?vue&type=script&lang=js&"
export * from "./menu.page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports